/**
 * SA-1078 (UX pass spec move 3): "What the AI is told", under the task's form,
 * closed unless this viewer opened it before (`localStorage`, the
 * `step-drawer:details` precedent — every access in try/catch). The content is
 * the drawer's `AiTold`, so the two surfaces never disagree.
 */
import { useId, useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { AiTold, type AiToldVM } from '@/components/process/AiTold'
import { AI_TOLD, AI_TOLD_KEY } from './taskPageText'

function readOpen(): boolean {
  try {
    return window.localStorage.getItem(AI_TOLD_KEY) === 'open'
  } catch {
    return false
  }
}

function writeOpen(open: boolean): void {
  try {
    window.localStorage.setItem(AI_TOLD_KEY, open ? 'open' : 'closed')
  } catch {
    // Not remembered; the disclosure still toggles.
  }
}

export function AiToldDisclosure({ ai }: { ai: AiToldVM }) {
  const [open, setOpen] = useState(readOpen)
  const panelId = useId()
  const Chevron = open ? ChevronDown : ChevronRight
  const toggle = () => {
    const next = !open
    setOpen(next)
    writeOpen(next)
  }
  return (
    <section className="text-sm">
      <button type="button" aria-expanded={open} aria-controls={open ? panelId : undefined} onClick={toggle}
        className="inline-flex items-center gap-1 text-xs text-muted-foreground underline-offset-2 hover:underline">
        <Chevron aria-hidden="true" className="size-3" />
        {AI_TOLD}
      </button>
      {open && <div id={panelId} className="mt-1.5"><AiTold ai={ai} /></div>}
    </section>
  )
}
